var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page printpage",class:_vm.pageClass()},[_c('dropzone-file-upload',{model:{value:(_vm.inputs.fileSingle),callback:function ($$v) {_vm.$set(_vm.inputs, "fileSingle", $$v)},expression:"inputs.fileSingle"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }